module.exports = __webpack_public_path__ + "img/es.99200fe4.png";